import { store } from './store';
import userAuthActions from '../services/auth/actions';

export default () =>
  new Promise(() => {
    store.dispatch(userAuthActions.getUserAuthData());
    store.dispatch(userAuthActions.getRefreshToken());
    // store.dispatch(userAuthActions.fetchActivePackageDetail());
  });
